import { ILocationForList } from "@services/locations";
import {
  ActionAddNewLocation,
  ActionBaseLocations,
  ActionDeleteLocation,
  ActionEditLocationType,
  ActionSetLocations,
  ActionTypesLocationsE,
} from "./actionTypes";

interface IState {
  initialized: boolean
  locations: ILocationForList[];
}

const initialState: IState = {
  initialized: false,
  locations: [],
};

const reducer = (state: IState = initialState, action: ActionBaseLocations): IState => {
  switch (action.type) {
    case ActionTypesLocationsE.SET_LOCATIONS:
      const locations = (action as ActionSetLocations).payload;
      return {
        ...state,
        initialized: true,
        locations,
      };
    case ActionTypesLocationsE.ADD_NEW_LOCATION:
      const location = (action as ActionAddNewLocation).payload;
      return {
        ...state,
        locations: [...state.locations, location],
      };
    case ActionTypesLocationsE.DELETE_LOCATION:
      const id = (action as ActionDeleteLocation).payload;
      const filteredLoc = state.locations.filter((item) => item.Id !== id);
      return {
        ...state,
        locations: filteredLoc,
      };
    case ActionTypesLocationsE.EDIT_LOCATION:
      const editedLoc = (action as ActionEditLocationType).payload;
      const index = state.locations.findIndex(
        (item) => item.Id === editedLoc.Id
      );

      return {
        ...state,
        locations: [
          ...state.locations.slice(0, index),
          editedLoc,
          ...state.locations.slice(index + 1),
        ],
      };

    default:
      return state;
  }
};

export default reducer;
